module.exports = __webpack_public_path__ + "static/img/pc-07.74b4a64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/x3/pc-07.jpg
// module id = hZi0
// module chunks = 1